import React from "react";
import "../styles/tokenomic.css";

import skyTerminal from "../assets/images/sky-terminal.png";
import skyMango from "../assets/images/sky-mango.png";

import discount from "../assets/icons/discount.svg";
import sofa from "../assets/icons/sofa.svg";
import hotel from "../assets/icons/hotel.svg";
import nft from "../assets/icons/nft.svg";
import dollar from "../assets/icons/dollar.svg";

const Tokenomic = () => {
  const benefits = [
    {
      icon: discount,
      title: "Flight Discount",
    },
    {
      icon: sofa,
      title: "VIP Lounge",
    },
    {
      icon: hotel,
      title: "Hotel Deals",
    },
    {
      icon: nft,
      title: "NFT Upgrade",
    },
    {
      icon: dollar,
      title: "Cashback",
    },
  ];

  return (
    <section className="tokenomic-section" id="tokenomic">
      <div className="container">

        <div className="tokenomic-card">

          {/* Top Row */}

          <div className="row g-4 align-items-stretch">

            <div className="col-lg-4">
              <div className="tokenomic-intro">

                <h2>03 TOKENOMIC</h2>

                <p>
                  Two tokens.
                  <br />
                  One ecosystem.
                </p>

              </div>
            </div>

            <div className="col-lg-4">
              <img
                src={skyTerminal}
                alt=""
                className="token-image"
              />
            </div>

            <div className="col-lg-4">
              <img
                src={skyMango}
                alt=""
                className="token-image"
              />
            </div>

          </div>

          {/* Benefits */}

          <div className="benefits-area">

            <h3>
              Use $MANGO for more
            </h3>

            <div className="row g-3">

              {benefits.map((item, index) => (
                <div
                  className="col-lg col-md-4 col-6"
                  key={index}
                >
                  <div className="benefit-card">

                    <img
                      src={item.icon}
                      alt=""
                    />

                    <span>
                      {item.title}
                    </span>

                  </div>
                </div>
              ))}

            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default Tokenomic;